import { ShieldCheck, Truck, RotateCcw, CreditCard } from "lucide-react";

const items = [
  { icon: ShieldCheck, title: "100% Original", desc: "Distribuidores oficiales" },
  { icon: RotateCcw, title: "30 días", desc: "Devoluciones sin coste" },
  { icon: Truck, title: "Envío rápido", desc: "Gratis desde $80" },
  { icon: CreditCard, title: "Pago seguro", desc: "Stripe · Apple Pay" },
];

export default function TrustBadges({ compact = false }) {
  return (
    <section className={`border-y border-border ${compact ? "py-6" : "py-10"}`} data-testid="trust-badges">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-12">
        {items.map(({ icon: Icon, title, desc }) => (
          <div key={title} className="flex items-center gap-4">
            <Icon strokeWidth={1} className="h-8 w-8 text-navy flex-shrink-0" />
            <div>
              <div className="font-serif text-base md:text-lg leading-tight">{title}</div>
              <div className="text-xs text-muted-foreground">{desc}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
